export { ContentPicture as default } from './content-picture';
export * from './content-picture';
